export default "__VITE_ASSET__4c0bb2b2__"